export enum EventInputEnum {
    NORTenderCargoInputId = 1,
    ReTenderNORCargoInputId = 233,
}
